module.exports = __webpack_public_path__ + "static/media/Icon_lines.95f74548.svg";